import { render, staticRenderFns } from "./FeedbackAttachmentDialog.vue?vue&type=template&id=30b0ff9c&scoped=true"
import script from "./FeedbackAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackAttachmentDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedbackAttachmentDialog.vue?vue&type=style&index=0&id=30b0ff9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b0ff9c",
  null
  
)

export default component.exports